import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { GeoRegion } from '@models/commons/geo-regions';
import { buildUrl } from '@wizbii-utils/angular/core';
import { LangEnum } from '@wizbii/utils/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class LocationWebservice {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${environment.api.suggestion}/internal/locations`;

  private readonly convertNormalizedGeographicalRegionResponseToGeoRegions = (
    response: NormalizedGeographicalRegionResponse
  ): GeoRegion[] => {
    const geoRegions: GeoRegion[] = [];

    Object.keys(response).forEach((countryCode) => {
      response[countryCode].forEach((item: string) => {
        geoRegions.push({
          countryCode: countryCode as Uppercase<LangEnum>,
          slug: item,
        });
      });
    });

    return geoRegions;
  };

  getDepartments(): Observable<GeoRegion[]> {
    const url = buildUrl(`${this.baseUrl}/departments`);
    return this.http.get<NormalizedGeographicalRegionResponse>(url).pipe(
      map((response) => {
        return this.convertNormalizedGeographicalRegionResponseToGeoRegions(response);
      })
    );
  }

  getContinents(): Observable<string[]> {
    const url = buildUrl(`${this.baseUrl}/continents`);
    return this.http.get<string[]>(url);
  }

  getCountries(): Observable<string[]> {
    const url = buildUrl(`${this.baseUrl}/countries`);
    return this.http.get<string[]>(url);
  }

  getStates(): Observable<GeoRegion[]> {
    const url = buildUrl(`${this.baseUrl}/states`);
    return this.http.get<NormalizedGeographicalRegionResponse>(url).pipe(
      map((response) => {
        return this.convertNormalizedGeographicalRegionResponseToGeoRegions(response);
      })
    );
  }

  searchCity(term: string): Observable<string[]> {
    const url = buildUrl(`${this.baseUrl}/cities`, { city: term });
    return this.http.get<string[]>(url);
  }
}
type NormalizedGeographicalRegionResponse = Record<string, string[]>;
